<template>
  <!-- <van-cell class="rank-master-container" :url="this.getUrl()"> -->
  <van-cell
    class="rank-master-container"
    @click="goToMaster()"
  >
    <div
      slot="title"
      class="left-cver"
    >
      <span class="rank-class">{{ rank }}</span>
      <van-image
        class="avater-class"
        fit="cover"
        round
        width="40px"
        height="40px"
        :src="avatarurl"
      ></van-image>
      <span class="name-class">{{ this.bjhinfo.name }}</span>
    </div>
    <span
      slot="default"
      class="hot-degree"
    >{{ article.heat }}</span>
  </van-cell>
</template>

<script>
import { getBjhRankBjhinfo } from '@/api/article'

export default {
  name: 'RankMasterItem',
  components: {},
  props: {
    article: {
      type: Object,
      required: true
    },
    rank: {
      type: Number
    }
  },
  data() {
    return {
      masterUrl: 'https://bjhh5.bjd.com.cn/master?column_id=',
      bjhinfo: {}
    }
  },
  computed: {
    avatarurl() {
      return this.bjhinfo?.avatar?.url
    }
  },
  watch: {},
  created() {
    // console.log(this.article.columnId)
    this.loadBjhInfo()
  },
  mounted() { },
  methods: {
    getUrl() {
      return `${this.article.shareUrl}&contentType=${this.article.contentType}&isBjh=1`
    },
    goToMaster() {
      // return this.masterUrl + this.article.columnId
      window.location = `https://mobile.bjd.com.cn/#/pages/bjh/special?info=1&uuid=${this.bjhinfo.uuid}&&isBang=1`
    },

    async loadBjhInfo() {
      console.log(this.article.columnId)
      const { data } = await getBjhRankBjhinfo({
        columnId: this.article.columnId
      })
      this.bjhinfo = data.data[this.article.columnId]
    }
  }
}
</script>

<style lang="less" scoped>
.rank-master-container {
  background-color: white;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 0px;
  padding-bottom: 0px;
  display: flex;
  align-items: center;

  .van-cell__title {
    flex: unset; // 取消flex ？
    width: 295px;
    height: 60px;
  }

  .left-cver {
    display: flex;
    align-items: center;
    height: 60px;

    .rank-class {
      padding-left: 14px;
      font-size: 17px;
      color: black;
    }

    .avater-class {
      padding-left: 14px;
    }

    .name-class {
      padding-left: 14px;
      font-size: 15px;
      color: #84600a;
    }
  }

  .hot-degree {
    padding-right: 14px;
    font-size: 16px;
    color: #e05a55;
  }
}
</style>
